import axios from "axios";
import authHeader from "./auth-header";
import { toast } from "react-toastify";

export const fetchAllHsn = (filters = {}) => {
  //   const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/hsn`, { headers: authHeader() })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
